export class CreateProfessionnelTirage
{
    montant:number;
    dateTirage:String;
    echeance:number;
    faciliteId:number;
}